import { Inject, Injectable } from '@angular/core';
import { USER_TOKEN_KEY } from '@boxx/login-core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { LocalStorageNativeService } from 'src/services/NativeLocalStorage.service';
import {
  IOnboardingService,
  ONBOARDING_SERVICE,
} from '../../services/IOnboarding.service';
import * as fromOnboardingActions from '../onboarding.actions';

@Injectable()
export class OnboardingRegistrationEffects {
  createUserData$ = createEffect(() =>
    this.actions.pipe(
      ofType(fromOnboardingActions.createUserBeginAction),
      switchMap((action) =>
        this.service.saveUserData(action.payload).pipe(
          map((payload) => {
            this.localStorage.setItem(USER_TOKEN_KEY, payload.token);

            return fromOnboardingActions.createUserSuccessAction({
              payload: action.payload,
            });
          }),
          catchError((errors) =>
            of([
              fromOnboardingActions.createUserFailAction({
                errors,
              }),
              fromOnboardingActions.clearOnboardingRegistraionSuccessErrorDataAction(),
            ]).pipe(switchMap((d) => d))
          )
        )
      )
    )
  );

  constructor(
    private actions: Actions,
    @Inject(ONBOARDING_SERVICE) private service: IOnboardingService,
    private localStorage: LocalStorageNativeService
  ) {}
}
